
const createPageMetaSlice = (set) => ({
  pageMeta: {
    title: 'Neki - Empowering organizations to do good',
    description: 'The social impact network for organizations to connect, share and engage with their colleagues through impact-driven activities and conversations',
    image: '/assets/images/neki-logo.svg',
  }
});

export default createPageMetaSlice;
